module.exports = "<div v-if=\"pages &gt; 1\" class=Pager><a :disabled=\"page &lt;= 1\" @click=page-- class=Pager__prev><i class=\"fa fa-long-arrow-left\"></i><span class=Pager__text>previous</span></a><a :disabled=\"page &gt;= pages\" @click.prevent=page++ class=Pager__next><span class=Pager__text>next</span><i class=\"fa fa-long-arrow-right\"></i></a></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/paginators/basic.vue
// module id = 468
// module chunks = 0